import getAppName from "../../utilities/get-app-name";

export default {
  // If you change the value of frontpageFiles here, you'll need to change it in the service worker as well (service-worker.js) as I define the same variable in there.
  appConfigImages: `${getAppName()}-app-config-images`,
};
